export default {
  // 欢迎页面
  welcome: {
    title: 'Welcome to AhaCreator',
    description: 'Learn how AhaCreator operates and master the steps to create, set up, and launch a campaign to achieve results.',
    startButton: 'Start the first Campaign'
  },

  // 步骤说明
  steps: {
    header: 'Conduct your campaign in 7 simple steps',
    step1: {
      title: 'Step 1: Enter your product website',
      description: 'AhaCreator streamlines setup and offers tailored recommendations throughout the process.'
    },
    step2: {
      title: 'Step 2: Choose Your Campaign Goal',
      description: 'Choose your main conversion goal for optimal campaigns, such as driving sales, generating leads, or building website traffic.'
    },
    step3: {
      title: 'Step 3: Confirm your maximum CPC and budget limit',
      description: 'Verify max CPC, then set monthly budget limit, region, and language for real-time estimates.'
    },
    step4: {
      title: 'Step 4: Confirm your audience',
      description: 'AhaCreator will match your audience; this audience will serve as a starting point to promote your product.'
    },
    step5: {
      title: 'Step 5: Launch Campaign',
      description: 'Verify payment, confirm conversion tracking, and launch when ready.'
    },
    step6: {
      title: 'Step 6: Confirm Creators and Contents On Time',
      description: 'Confirm creators within one day and review their scripts and drafts within two days to prevent automatic progression.'
    },
    step7: {
      title: 'Step 7: Receive Results and Reports',
      description: "We provides you with a weekly performance summary. With AI autopilot mode, there's no need to check data daily or make countless decisions."
    }
  }
};
